import React, { useEffect, useState, useRef } from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import styles from '../styles/Recognition.module.scss';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Modal from "react-bootstrap/Modal";
import fetchUtil from "../utils/fetchUtil";
import CustomImage from "./CustomImage";

interface Props {
  bgColor: string
}

const Recognition: React.FC<Props> = ({ bgColor }) => {

  const [selectedImage, setSelectedImage] = useState<string>('')
  const [recognitions, setRecognitions] = useState<any>([])


  useEffect(() => {
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/recognitions`, 'GET', {}, '', false)
      .then((res: any) => setRecognitions(res.recognitions))
  }, [])

  const sliderRefs = useRef<Array<Slider | null>>([]);
  const settings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }

    ]
  };
  const cardsRender = (certificates: any, index: number) => {

    return (
      <>
        <Slider {...settings} ref={(slider) => (sliderRefs.current[index] = slider)} className={styles.slider} >
          {
            certificates.map((certificate: any) => {
              return (
                <div id="regi-slider-div" className={styles.regiSliderDiv}>
                  <Card className={styles.cardCustRecog} onClick={() => setSelectedImage(certificate.certificateUrl)}>
                    <Card.Body>
                      <div className={styles.logoContainer}>
                        <CustomImage src={certificate.logoUrl} alt={certificate.logoAltTag} width={200} height={140} />
                      </div>
                      <Card.Title className={styles.titleHeight}>{certificate.logoName}</Card.Title>
                      <CustomImage src="/new-images/starrecog.svg" width={70} height={20} className={styles.startRegImg} alt={"starrecog"} />
                      <div className={styles.titleBlue}>{certificate.certificateName}</div>
                      <div className={styles.dateText}>{certificate.yearField}</div>
                      {certificate?.link && <a href={certificate?.link} target="_blank" className={styles.link}><span>Visit {certificate?.linkText} Website</span></a>}
                    </Card.Body>
                  </Card>
                </div>
              )
            })
          }
        </Slider>
        <div id="arrowsid" className={styles.arrowsClass}>
          <div className={styles.btcircle} onClick={() => sliderRefs?.current?.[index]?.slickPrev()}>
            <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
          </div>
          <div className={styles.btcircle} onClick={() => sliderRefs?.current?.[index]?.slickNext()}>
            <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
          </div>
        </div>
      </>
    )
  }

  const controlledTabs = () => {
    return (
      <Tabs id="certficate-recog" unmountOnExit defaultActiveKey={recognitions[0].title} className={styles.recogTabs} style={{ backgroundColor: bgColor }}>
        {
          recognitions.map((recog: any, index: number) => {
            return (
              <Tab eventKey={recog.title} title={recog.title} className={styles.custtab}>
                {recog?.certificates?.length > 0 && cardsRender(recog.certificates, index)}
              </Tab>
            )
          })
        }
      </Tabs>
    );
  }
  return (
    <>
      {recognitions.length > 0
        ? <div id="recongnition" className={styles.recongnition}>
          <Container style={{ position: "relative" }}>
            <Row className="text-center">
              <h2>Recognitions</h2>
            </Row>
            {controlledTabs()}
          </Container>
        </div>
        : null}
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={selectedImage ? true : false}
        onHide={() => setSelectedImage('')}
      >
        <Modal.Body>
          <CustomImage src={selectedImage || '/'} alt={selectedImage || ''} width={500} height={650} />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Recognition;